import type { VisibilityScope } from "@/services/api/agentic-v2";

/** Filters managed by the missions list UI (maps to ``ListMissionsParams``). */
export interface MissionsFilters {
  templateId: string | "all";
  statusFilter: "needs_attention" | "active" | "completed" | "all";
  assigned: "me" | "team" | "everyone";
  q: string;
}

export const DEFAULT_MISSIONS_FILTERS: MissionsFilters = {
  templateId: "all",
  statusFilter: "all",
  assigned: "everyone",
  q: "",
};

/** Caseload scope from Mission Control toolbar (overrides ``filters.assigned``). */
export interface MissionsCaseloadScope {
  visibility: VisibilityScope;
  asUserId?: string | null;
}
